<script setup lang="ts">
import { computed } from "vue";
import PhosphorIcon from "./PhosphorIcon.vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    loading?: boolean;
    icon?: string;
    phosphorIcon?: string;
    label: string;
    /** Trait de séparation au-dessus de l'entrée (groupe d'actions distinct). */
    divided?: boolean;
    type?: "default" | "primary" | "success" | "warning" | "danger";
  }>(),
  {
    disabled: false,
    loading: false,
    divided: false,
    type: "default",
  }
);

const emit = defineEmits<{
  (e: "select"): void;
}>();

const handleClick = () => {
  if (!props.disabled) {
    emit("select");
  }
};

const textClass = computed(() => {
  switch (props.type) {
    case "primary":
      return "text-primary";
    case "success":
      return "text-success";
    case "warning":
      return "text-warning";
    case "danger":
      return "text-danger";
    default:
      return "";
  }
});
</script>

<template>
  <el-dropdown-item
    :disabled="disabled"
    :divided="divided"
    @click="handleClick()"
    :class="textClass"
  >
    <el-icon size="1.5rem" :class="textClass">
      <span
        v-if="loading"
        class="spinner-border spinner-border-sm"
        role="status"
      ></span>
      <PhosphorIcon v-else-if="phosphorIcon" :name="phosphorIcon" :size="20" />
      <i v-else-if="icon" :class="icon"></i>
    </el-icon>
    <span>{{ label }}</span>
  </el-dropdown-item>
</template>

<style lang="scss">
.el-dropdown-menu__item {
  height: 4rem !important;
  padding: 1.6rem 1rem !important;
}
</style>
